// extracted by mini-css-extract-plugin
var _1 = "chat-header__VcHm3";
export { _1 as "chatHeader" }
